import organization from 'app/entities/organization/organization.reducer';
import organizationConfiguration from 'app/entities/organization-configuration/organization-configuration.reducer';
import submission from 'app/entities/submission/submission.reducer';
import organizationWorkflow from 'app/entities/organization-workflow/organization-workflow.reducer';
import submissionRequest from 'app/entities/submission-request/submission-request.reducer';
import envVar from 'app/entities/env-var/env-var.reducer';
import workflowDocuments from 'app/entities/workflow-documents/workflow-documents.reducer';
import systemAiFunction from 'app/entities/system-ai-function/system-ai-function.reducer';
import systemAiPrompt from 'app/entities/system-ai-prompt/system-ai-prompt.reducer';
import merchant from 'app/entities/merchant/merchant.reducer';
import deal from 'app/entities/deal/deal.reducer';
import userDeals from 'app/entities/user-deals/user-deals.reducer';
import product from 'app/entities/product/product.reducer';
import dealProduct from 'app/entities/deal-product/deal-product.reducer';
import userCashBack from 'app/entities/user-cash-back/user-cash-back.reducer';
import userCashBackDeal from 'app/entities/user-cash-back-deal/user-cash-back-deal.reducer';
import brand from 'app/entities/brand/brand.reducer';
import publisher from 'app/entities/publisher/publisher.reducer';
import customer from 'app/entities/customer/customer.reducer';
import correction from 'app/entities/correction/correction.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

const entitiesReducers = {
  organization,
  organizationConfiguration,
  submission,
  organizationWorkflow,
  submissionRequest,
  envVar,
  workflowDocuments,
  systemAiFunction,
  systemAiPrompt,
  merchant,
  deal,
  userDeals,
  product,
  dealProduct,
  userCashBack,
  userCashBackDeal,
  brand,
  publisher,
  customer,
  correction,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
};

export default entitiesReducers;
